import { useEffect, useState } from 'react';

import { checkImage } from '../util/helperfunctions';

export function useImageExists(imageUrl: string | undefined): boolean {
  const [imageExists, setImageExists] = useState(false);

  useEffect(() => {
    if (imageUrl) {
      checkImage(imageUrl).then(setImageExists);
    }
  }, [imageUrl]);

  return imageExists;
}
